export default __webpack_public_path__ + "static/media/prize-3-bm.1ad133ff.webp";